import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export function Breadcrumb({ labelMap = {} }) {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean); // ["admin", "tenants", ...]

  const crumbs = [];
  let path = "";
  segments.forEach((seg, i) => {
    path += `/${seg}`;
    if (seg === "admin") return;
    const label = labelMap[path] || seg.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    crumbs.push({ label, path, last: i === segments.length - 1 });
  });

  return (
    <nav className="flex items-center gap-1.5 text-sm text-muted-foreground mb-5" data-testid="breadcrumb">
      <Link to="/admin/dashboard" className="hover:text-foreground transition-colors flex items-center">
        <Home className="h-3.5 w-3.5" />
      </Link>
      {crumbs.map((c) => (
        <span key={c.path} className="flex items-center gap-1.5">
          <ChevronRight className="h-3.5 w-3.5 opacity-50" />
          {c.last ? (
            <span className="font-medium text-foreground">{c.label}</span>
          ) : (
            <Link to={c.path} className="hover:text-foreground transition-colors">{c.label}</Link>
          )}
        </span>
      ))}
    </nav>
  );
}
